import React from "react";
import "./Gallery.css"
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import gallery1 from "./images/gallery1.jpeg";
import gallery2 from "./images/gallery2.jpeg";
import gallery3 from "./images/gallery3.jpeg";
import gallery4 from "./images/gallery4.jpeg";
import gallery5 from "./images/gallery5.jpeg";
import gallery6 from "./images/gallery6.jpeg";
import gallery7 from "./images/gallery7.jpeg";
import gallery8 from "./images/gallery8.jpeg";
import gallery9 from "./images/gallery9.jpeg";
import gallery10 from "./images/gallery10.jpeg";
import gallery11 from "./images/gallery11.jpeg";

class Gallery extends React.Component {
    render() {
        return (
            <div>
                <NavBar/>
                <div id="gallery-page">
                    <p>Kids in Seats Gallery</p>
                    <div id="gallery-container">
                        <img src={gallery9} alt="gallery picture1"/>
                        <img src={gallery10} alt="gallery picture2"/>
                        <img src={gallery2} alt="gallery picture3"/>
                        <img src={gallery3} alt="gallery picture4"/>
                        <img src={gallery1} alt="gallery picture5"/>
                        <img src={gallery5} alt="gallery picture6"/>
                        <img src={gallery4} alt="gallery picture7"/>
                        <img src={gallery7} alt="gallery picture8"/>
                        <img src={gallery6} alt="gallery picture9"/>
                        <img src={gallery8} alt="gallery picture10"/>
                        <img src={gallery11} alt="gallery picture11"/>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Gallery;